// extracted by mini-css-extract-plugin
export default {"button":"loadingButton_button__C5KIY"};